import React, { useState } from 'react'
import { useEffect } from 'react';
import JsonData from "../data/data.json";
import { Gallery } from '../components/gallery';
import Footer from "../components/footer";

const PortfolioPage = () => {
    const [landingPageData, setLandingPageData] = useState({});
    useEffect(() => {
      setLandingPageData(JsonData);
    }, []);
  return (
    <>
    <Gallery ongoing={landingPageData.Ongoing} completed={landingPageData.Completed} />
    <Footer/>
    </>
  )
}

export default PortfolioPage